import { render, staticRenderFns } from "./FolderTree.vue?vue&type=template&id=2d2ead7f&"
import script from "./FolderTree.vue?vue&type=script&lang=js&"
export * from "./FolderTree.vue?vue&type=script&lang=js&"
import style0 from "./FolderTree.vue?vue&type=style&index=0&id=2d2ead7f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports